const specDetailElement = document.querySelector("[data-component='home-detail-data']");
const specDetailData = specDetailElement?.innerHTML
  ? JSON.parse(specDetailElement.innerHTML)
  : {};

if (specDetailData?.hasSelfGuidedTour) {
  require('./components/selfGuidedWidget');
}

require('features/segment');
require('./components/eventTracking/segmentEventsHandler');
require('features/googleAnalytics4');
require('./components/eventTracking/googleAnalytics4EventsHandler');
